import { config, IJsonRpcResponse } from "../api";

interface IChargeResponse extends IJsonRpcResponse {
    result: {
        success: boolean;
        message: string;
    }
}

export const charge = async (
    customerID: number,
    chargeAmount: string,
    creditDeduction: string,
    note: string
) => {
    const amount = parseFloat(chargeAmount) * 100;
    const creditAmount = parseFloat(creditDeduction) * 100;
    const params = {
        amount,
        creditAmount,
        customerID,
        note
    };

    const authToken = config.authToken;
    const res = await fetch(`${config.url}/manualCharge`, {
        body: JSON.stringify(params),
        headers: {
            'Authorization': 'Bearer ' + authToken,
            'Content-Type': 'application/json'
        },
        method: 'post',
        mode: 'cors'
    });
    const body: IChargeResponse = await res.json();
    return body.result;
};
